import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const EditTagsPage = () => {
  const { tagsId } = useParams();
  const navigate = useNavigate();

const [getTagsName, setTagsName] = useState("");
const [getTagsSlag, setTagsSlag] = useState("");
const [getTagsMeta_title, setTagsMeta_title] = useState("");
const [getTagsMeta_desc, setTagsMeta_desc] = useState("");
const [getTagsMeta_keyword, setTagsMeta_keyword] = useState("");
const [getTagsPage_desc, setTagsPage_desc] = useState("");

  // =========================
  // FETCH TAG BY ID
  // =========================
  const fetchTagById = async () => {
    try {
      const res = await api.get(`/adminBlog/getTagsById/${tagsId}`);

      if (res.data.success) {
        const data = res.data.data;

        setTagsName(data.name);
        setTagsSlag(data.slug);
        setTagsMeta_title(data.meta_title);
        setTagsMeta_desc(data.meta_desc);
        setTagsMeta_keyword(data.meta_keyword);
        setTagsPage_desc(data.page_desc);
      } else {
        toast.error("Tag not found");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch tag");
    }
  };

  useEffect(() => {
    if (tagsId) fetchTagById();
  }, [tagsId]);


  useEffect(() => {
    const slugData = getTagsName
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");
  
    setTagsSlag(slugData);
  }, [getTagsName]);

  // =========================
  // UPDATE TAG
  // =========================
  const updateTag = async () => {
    if (!getTagsName) {
      toast.error("Tag name required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Update Tag?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Update"
    });

    if (!confirm.isConfirmed) return;

    try {
      const payload = {
        tag_id: tagsId,
        tags: getTagsName,
        slug :getTagsSlag,
        meta_title: getTagsMeta_title,
        meta_desc: getTagsMeta_desc,
        meta_keyword: getTagsMeta_keyword,
        page_desc: getTagsPage_desc,
      };

      const res = await api.put(
        `/adminBlog/updateTags/${tagsId}`,
        payload
      );

      if (res.data.success) {
        Swal.fire("Success", "Tag Updated", "success");
        navigate("/tags/manage-tags");
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Server Error");
    }
  };

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between">
          <h4>Edit Tag</h4>

          <Link to="/tags/manage-tags" className="btn btn-secondary btn-sm">
            <ArrowLeft size={16} /> Back
          </Link>
        </div>
      </div>

      {/* FORM */}
      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Tag Name</th>
                <th>Slug</th>
              </tr>
            </thead>

            <tbody>
          
                <tr>
                  <td>
                    <input
                      className="form-control"
                      value={getTagsName}
                      onChange={(e) =>
                        setTagsName(e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                    readOnly
                      className="form-control"
                      value={getTagsSlag}
                      onChange={(e) =>
                        setTagsSlag(e.target.value)
                      }
                    />
                  </td>
                </tr>
             
            </tbody>
            <thead>
              <tr>
                <th>   <div className="d-flex align-items-center gap-2">
                        <span>Meta Title</span>
                        <small className={`d-block mt-1 ${
                           (getTagsMeta_title?.length || 0) > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getTagsMeta_title?.length || 0)}/80 Characters)
                        </small>
                     </div></th>
                <th>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Description</span>
                        <small className={`d-block mt-1 ${
                           (getTagsMeta_desc?.length  || 0)> 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getTagsMeta_desc?.length || 0)}/160 Characters)
                        </small>
                     </div>
                </th>
              </tr>
            </thead>
            
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" className="form-control" maxLength={80} value={getTagsMeta_title} onChange={(e) => setTagsMeta_title(e.target.value)} />
                     {(getTagsMeta_title?.length || 0) >= 79 && (getTagsMeta_title?.length || 0) <= 80 && (
                     <small className="text-danger">
                     ⚠️ Almost reached limit
                     </small>
                     )}
                  </td>

                  <td>
                   <textarea className="form-control"  rows="3"  maxLength={160} value={getTagsMeta_desc} onChange={(e) => setTagsMeta_desc(e.target.value)} />
               {(getTagsMeta_desc?.length || 0 )>= 159 && (getTagsMeta_desc?.length || 0) <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                  </td>
                </tr>
                
       
            </tbody>
             <thead>
              <tr>
                <th>
                     <div className="d-flex align-items-center gap-2">
               <span>Meta Keyword  </span><small className={`d-block mt-1 ${
                  (getTagsMeta_keyword?.length || 0 )> 255 ? "text-danger" : "text-muted"
               }`}>
               ({(getTagsMeta_keyword?.length || 0 )}/255 Characters)
               </small>
               </div>
                </th>
                <th>Page Description</th>
              </tr>
            </thead>
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" maxLength={255} className="form-control" value={getTagsMeta_keyword} onChange={(e) => setTagsMeta_keyword(e.target.value)} ></textarea>
               {(getTagsMeta_keyword?.length || 0)>= 254 && (getTagsMeta_keyword?.length || 0) <= 255 && (
               <small className="text-danger">
               ⚠️ Almost reached limit
               </small>
               )}
                  </td>

                  <td>
                    <textarea
                  rows="3"
                      className="form-control"
                      
                      value={getTagsPage_desc}
                      onChange={(e) =>
                        setTagsPage_desc(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
          </table>

          <button className="btn btn-success mt-3" onClick={updateTag}>
            Update Tag
          </button>

        </div>
      </div>
    </div>
  );
};

export default EditTagsPage;